export const QUOTE_OPERATION_STATES = {
  NONE: 'NONE',
  UPDATING: 'UPDATING',
};

export const QUOTE_OPERATION_STATES_LIST = Object.keys(QUOTE_OPERATION_STATES);

export const QUOTE_OPERATION_STATE_ERROR = 'quoteOperationState is PENDING';
